import LcTabs from './Tabs';
export default LcTabs;
